import axios from "axios";

export default function ReceiptStornoService(receiptId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptId + "/storno",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
